import { getGelTokens } from "@tal-gel/theming";
import styled from "@emotion/styled";

const Spacer = styled.div(() => ({
    paddingTop: getGelTokens().global.sizeBaseX5
}));

export default Spacer;